export const DEFAULT_LOCALE = "en-GB";

export const SUPPORTED_LOCALES = [
  "en-GB",
  "nl-NL",
  "de-DE",
  "fr-FR",
  "es-ES",
  "pt-PT",
  "it-IT",
] as const;

function normalizeLocaleCode(locale: string): string {
  const normalized = locale.replace("_", "-").trim();
  const [language = "", region = ""] = normalized.split("-");
  if (!language) return "";
  if (!region) return language.toLowerCase();
  return `${language.toLowerCase()}-${region.toUpperCase()}`;
}

export function resolveLocaleFallbacks(locale?: string): string[] {
  if (!locale) return [DEFAULT_LOCALE];

  const normalized = normalizeLocaleCode(locale);
  if (!normalized) return [DEFAULT_LOCALE];

  const [baseLanguage] = normalized.split("-");
  const sameLanguageLocales = SUPPORTED_LOCALES.filter(
    (supported) =>
      supported.toLowerCase() !== normalized.toLowerCase() &&
      supported.toLowerCase().startsWith(`${baseLanguage}-`),
  );

  const fallbacks = [...sameLanguageLocales];
  if (!fallbacks.includes(DEFAULT_LOCALE)) {
    fallbacks.push(DEFAULT_LOCALE);
  }

  return fallbacks;
}
